import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";
// import iziToast from "izitoast";

export const UserTest = () => {
    const { apipath, filepath, logout } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const tId = localStorage.getItem('tId');
    const userData = JSON.parse(localStorage.getItem('userData'));
    const [questionsData, setQuestionsData] = useState([]);
    const [testData, setTestData] = useState({});
    const [userTest, setUserTest] = useState({});
    const [totalQuestions, setTotalQuestions] = useState(0);
    const [imgpath, setImgpath] = useState("");
    const [teststart, setTestStart] = useState(false);
    const [timeLeft, setTimeLeft] = useState(() => {
        // Get time from localStorage or initialize with initialTime
        const storedTime = localStorage.getItem('timeLeft');
        return storedTime ? parseInt(storedTime, 10) : 0;
    });
    useEffect(() => {
        if (!tId) {
            navigate('/student_dashboard');
        }
    }, []);
    const subjects = Object.keys(questionsData);
    const [selectedOption, setSelectedOption] = useState({});
    const [selectedSubject, setSelectedSubject] = useState("");

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [questionStatus, setQuestionStatus] = useState({}); // To track statuses of questions
    const [selectedAnswers, setSelectedAnswers] = useState({}); // To track selected options
    const [timeTaken, setTimeTaken] = useState({}); // To track selected options
    const [questionStartTime, setQuestionStartTime] = useState(Date.now());

    const getTest = async () => {
        try {
            const response = await axios.post(
                apipath + '/userTest',
                { id: tId },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            // console.log(response.data);
            if (response.data.status === "unauthentic") {
                localStorage.removeItem('token');
                navigate('/');
            }
            if (response.data.teststatus === 'submitted') {
                iziToast.warning({
                    'message': 'Test Already Submitted!',
                    'position': 'topCenter'
                });
                navigate('/student_dashboard');
            }
            // console.log(response.data);
            const result = response.data;
            const ques = result.questions;
            const subjs = Object.keys(ques);
            setSelectedSubject(subjs[0]);
            setQuestionsData(ques);
            setTotalQuestions(result.totalQuestions);
            setTestData(result.test?.test);
            setUserTest(result.userTest);
            setImgpath(filepath + "/public/questionImages_" + result.test?.test?.id + "/");
            setTestStart(true);
            const lefttime = localStorage.getItem('timeLeft');
            const myanswers = result.selectedanswers;
            const timetaken = result.timetaken;
            if (lefttime === null) {
                setTimeLeft(result.timeleft);
            }
            setSelectedAnswers(myanswers ?? {});
            setTimeTaken(timetaken ?? {});
            for (const key in myanswers) {
                if (myanswers[key] !== null) {
                    questionStatus[key] = 'saved';
                }
                else {
                    questionStatus[key] = 'unattempted';
                }
            }
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();

            }

        } finally {

        }
    }
    const updateTimeTaken = () => {
        if (currentQuestion?.qid) {
            const currentTime = Date.now();
            const timeSpent = Math.floor((currentTime - questionStartTime) / 1000); // seconds
            setTimeTaken(prev => ({
                ...prev,
                [currentQuestion.qid]: (prev[currentQuestion.qid] || 0) + timeSpent
            }));
        }
        setQuestionStartTime(Date.now());
    };

    useEffect(() => {
        getTest();
        window.history.pushState(null, "", window.location.href);

        // const handlePopState = () => {
        //   // Push the dummy entry back to history
        //   console.log('hi');
        //   window.history.pushState(null, "", window.location.href);
        // };

        // window.addEventListener("popstate", handlePopState);
    }, []);

    useEffect(() => {
        // console.log(teststart);
        // console.log(timeLeft);
        if (timeLeft > 0) {
            localStorage.setItem('timeLeft', timeLeft); // Update localStorage
        }
        if (teststart && timeLeft === 0) {
            handleSubmit('submitted');
        }
        if (timeLeft === 600) {
            iziToast.warning({
                'message': 'Attention Please! Only 10 minutes Left!',
                'position': 'topCenter'
            });
        }
        if (timeLeft === 300) {
            iziToast.warning({
                'message': 'Attention Please! Only 5 minutes Left!',
                'position': 'topCenter'
            });
        }

        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                const newTime = prevTime - 1;
                if (newTime <= 0) {
                    clearInterval(timer); // Clear the timer when it reaches 0
                    localStorage.removeItem('timeLeft'); // Optional: Clear localStorage
                    return 0;
                }
                return newTime;
            });
        }, 1000);

        return () => clearInterval(timer); // Cleanup on component unmount
    }, [timeLeft]);

    // Format the time as MM:SS
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    };

    const handleSubmit = async (status) => {
        // console.log(status);
        // if (Object.keys(selectedAnswers).length > 0) {
        //     // console.log(questionStatus);
        // }
        try {
            console.log(timeTaken);
            // return false;
            if (testData.id && Object.keys(selectedAnswers).length > 0) {
                const response = await axios.post(
                    apipath + '/submitTest',
                    { 'testId': userTest.id, 'status': status, 'test_data': selectedAnswers, 'time_left': timeLeft, 'time_taken': timeTaken },
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                // console.log(response.data);
                if (status === 'submitted') {
                    localStorage.removeItem('timeLeft');
                }
                if (response.data.status === "unauthentic") {
                    localStorage.removeItem('token');
                    navigate('/');
                }
                if (response.data.status === "submitted") {
                    iziToast.success({
                        message: 'Test Submitted Successfully.',
                        position: 'topCenter'
                    });

                    navigate('/thanks', { replace: true });
                    // navigate('/student_dashboard');
                }
            }
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }

        } finally {

        }
    }

    const [activeTab, setActiveTab] = useState("Test");


    const questions = questionsData[selectedSubject] || [];
    const currentQuestion = questions[currentQuestionIndex] || null;

    const handleSubjectChange = (subject) => {
        updateTimeTaken();
        setSelectedSubject(subject);
        setCurrentQuestionIndex(0); // Show the first question of the selected subject
    };

    useEffect(() => {
        // console.log(selectedAnswers);
        setSelectedOption({});
        if (currentQuestion) {
            if (selectedAnswers[currentQuestion.qid]) {
                setSelectedOption({
                    ...selectedOption,
                    [currentQuestion.qid]: selectedAnswers[currentQuestion.qid],
                });
            }
        }
    }, [currentQuestion]);

    const handleSaveAndNext = () => {

        if (selectedOption[currentQuestion.qid]) {
            setSelectedAnswers({
                ...selectedAnswers,
                [currentQuestion.qid]: selectedOption[currentQuestion.qid],
            });
            setQuestionStatus({
                ...questionStatus,
                [currentQuestion.qid]: 'saved',
            });
        }
        // setSelectedOption({});
        handleNext();
        // handleSubmit('saved');
    };

    const handleMarkForReview = () => {
        // console.log(currentQuestion);
        setQuestionStatus({
            ...questionStatus,
            [currentQuestion.qid]: 'review',
        });
        handleNext();
    };

    const handleNext = () => {
        updateTimeTaken();
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
        else if (currentQuestion.id + 1 < totalQuestions) {
            var subind = subjects.indexOf(selectedSubject);
            if (subind < subjects.length) {
                const nextIndex = subind + 1;
                const nextSubject = subjects[nextIndex];
                // console.log(nextIndex);
                handleSubjectChange(nextSubject);
            }
        }
        // console.log(selectedOption);
        console.log(timeTaken);
        // setSelectedOption({});
    };

    const handlePrevious = () => {
        updateTimeTaken();
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
        else if (currentQuestion.id > 0) {
            var subind = subjects.indexOf(selectedSubject);
            if (subind > 0) {
                const nextIndex = subind - 1;
                const nextSubject = subjects[nextIndex];
                // console.log(nextIndex);
                handleSubjectChange(nextSubject);
            }
        }
        // setSelectedOption({});
    };
    useEffect(() => {
        // console.log(selectedAnswers);
        localStorage.setItem('answers', JSON.stringify(selectedAnswers));
        if (selectedAnswers) {
            handleSubmit('started');
        }
    }, [selectedAnswers]);

    const handleAttempted = async (option) => {
        setSelectedOption({
            ...selectedOption,
            [currentQuestion.qid]: option,
        });
        // console.log(option);
    };

    const handleClearSelection = (questionId) => {
        setSelectedAnswers((prevAnswers) => ({
            ...prevAnswers,
            [questionId]: null, // Unset the answer for this question
        }));
        setSelectedOption((prevAnswers) => ({
            ...prevAnswers,
            [questionId]: null, // Unset the answer for this question
        }));
        setQuestionStatus({
            ...questionStatus,
            [currentQuestion.qid]: 'unattempted',
        });
    };

    const getButtonStyle = (index, subject) => {
        // if (subject === selectedSubject && index === currentQuestionIndex) {
        //     return 'border-2 border-black'; // Highlight current question
        // }
        if (questionStatus[index] === 'saved') return 'border-green-400 text-black';
        if (questionStatus[index] === 'review') return 'border-yellow-400 text-black shadow-[0_0_3px_1px_rgba(250,175,2,0.5)]';
        if (questionStatus[index] === 'attempted') return 'border-green-400 text-black';
        return 'border-red-600 text-black'; // Default for unattempted
    };

    const getOptionStyle = (option) => {
        if (selectedAnswers) {
            return selectedAnswers[currentQuestionIndex] === option
                ? 'bg-green-200 border-green-500'
                : 'bg-white';
        }
    };


    return (
        <>
            {<Navbar />}
            <img className="fixed right-2 md:left-[50%] z-50 w-10 h-10" src={`${filepath}/public/testImages/${testData.image}`} />
            <div className="flex flex-col md:flex-row">
                {/* {<Sidebar activePage={"exams"} />} */}
                <div class="main-content flex-1 bg-gray-100 pb-4 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">
                    <div className="flex flex-wrap">
                        <div className="w-full p-2">
                            <div className="fluid mx-auto pb-2">
                                {/* Subject Selector as Buttons */}

                                <div className="flex">
                                    {/* Question Display */}
                                    <div className="w-3/4 bg-white border rounded shadow-md shadow-gray-300 m-1">
                                        <div className="flex flex-col sm:flex-row m-0 py-2 px-4 justify-between items-center shadow-md shadow-gray-300">
                                            <div className="flex flex-wrap space-y-2">
                                                <span className="mt-2 mr-2 py-1 font-bold">Subjects : </span>
                                                {Object.keys(questionsData).map((subject) => (
                                                    <button
                                                        key={subject}
                                                        onClick={() => handleSubjectChange(subject)}
                                                        className={`px-4 mr-2 py-1 rounded border border-teal-500 hover:bg-teal-500 hover:border-teal-500 hover:text-white ${selectedSubject === subject ? 'bg-teal-500 text-white shadow-[0px_3px_4px_0px_rgba(0,137,123,0.4)]' : 'bg-white text-teal-500'
                                                            }`}
                                                    >
                                                        {subject}
                                                    </button>
                                                ))}
                                            </div>
                                            <h1 className="mb-3  p-2 text-center font-bold">Timing: {formatTime(timeLeft)}</h1>
                                        </div>
                                        {(currentQuestion) ? <>
                                            <div className="py-2 min-h-[65vh] max-h-[65vh] overflow-auto">
                                                <h2 className="text-xl font-bold mb-4 px-4">
                                                    Question {currentQuestion.id + 1}: <span className={currentQuestion.language}>{currentQuestion.question}</span>
                                                </h2>

                                                {currentQuestion.question_image && (
                                                    <img
                                                        src={imgpath + currentQuestion.question_image}
                                                        alt="Question"
                                                        className="w-96 mb-4 px-4"
                                                    />
                                                )}

                                                <div className="space-y-4 px-4 pb-4">
                                                    <label
                                                        className={`block w-fit p-2 cursor-pointer ${getOptionStyle(currentQuestion.id + 'a')}`}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name={`question-${currentQuestion.id}`}
                                                            value="a"
                                                            checked={selectedOption[currentQuestion.qid] === "a"}
                                                            onChange={() => handleAttempted("a")}
                                                            className="mr-2"
                                                        />
                                                        {(currentQuestion.option1) ? <><span className={`${currentQuestion.language}`}>{currentQuestion.option1}</span></> : <img src={imgpath + currentQuestion.option1_image} className="w-84 mb-4 inline" alt="" />}
                                                    </label>
                                                    <label
                                                        className={`block w-fit p-2 cursor-pointer ${getOptionStyle(currentQuestion.id + 'b')}`}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name={`question-${currentQuestion.id}`}
                                                            value="b"
                                                            checked={selectedOption[currentQuestion.qid] === "b"}
                                                            onChange={() => handleAttempted("b")}
                                                            className="mr-2"
                                                        />
                                                        {(currentQuestion.option2) ? <><span className={`${currentQuestion.language}`}>{currentQuestion.option2}</span></> : <img src={imgpath + currentQuestion.option2_image} className="w-84 mb-4 inline" alt="" />}
                                                    </label>
                                                    <label
                                                        className={`block w-fit p-2 cursor-pointer ${getOptionStyle(currentQuestion.id + 'c')}`}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name={`question-${currentQuestion.id}`}
                                                            value="c"
                                                            checked={selectedOption[currentQuestion.qid] === "c"}
                                                            onChange={() => handleAttempted("c")}
                                                            className="mr-2"
                                                        />
                                                        {(currentQuestion.option3) ? <><span className={`${currentQuestion.language}`}>{currentQuestion.option3}</span></> : <img src={imgpath + currentQuestion.option3_image} className="w-84 mb-4 inline" alt="" />}
                                                    </label>
                                                    <label
                                                        className={`block w-fit p-2 cursor-pointer ${getOptionStyle(currentQuestion.id + 'd')}`}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name={`question-${currentQuestion.id}`}
                                                            value="d"
                                                            checked={selectedOption[currentQuestion.qid] === "d"}
                                                            onChange={() => handleAttempted("d")}
                                                            className="mr-2"
                                                        />
                                                        {(currentQuestion.option4) ? <><span className={`${currentQuestion.language}`}>{currentQuestion.option4}</span></> : <img src={imgpath + currentQuestion.option4_image} className="w-84 mb-4 inline" alt="" />}
                                                    </label>
                                                </div>

                                                {/* Action Buttons */}
                                            </div>
                                            <div className="flex flex-row justify-between pb-2 px-4">
                                                <div className="mt-4 flex flex-wrap sm:flex-nowrap">
                                                    <button onClick={handlePrevious} className="p-2 mb-1 mr-2  hover:bg-teal-600 hover:text-white border border-teal-600 text-teal-600 rounded">
                                                        Previous
                                                    </button>
                                                    <button onClick={handleNext} className="p-2 mb-1 mr-2  hover:bg-teal-600 hover:text-white border border-teal-600 text-teal-600 rounded">
                                                        Next
                                                    </button>
                                                    <button onClick={handleMarkForReview} className="p-2 mb-1 mr-2 hover:bg-teal-600 hover:text-white border border-teal-600 text-teal-600 rounded">
                                                        Mark & Next
                                                    </button>
                                                    <button onClick={() => handleClearSelection(currentQuestion.qid)} className="p-2 mb-1 mr-2 hover:bg-teal-600 hover:text-white border border-teal-600 text-teal-600 rounded">
                                                        Clear Response
                                                    </button>
                                                    <button onClick={handleSaveAndNext} className="p-2 mb-1 mr-2 bg-teal-600 hover:bg-teal-700 text-white rounded">
                                                        Save & Next
                                                    </button>
                                                </div>
                                            </div>
                                        </> : ""}
                                    </div>

                                    {/* All Questions Display on the Right */}
                                    <div className="w-1/4 bg-white flex flex-col items-center border rounded shadow-md shadow-gray-300 pb-4 m-1">
                                        <h1 className="bg-teal-600 rounded p-2 w-full text-white text-center">{(testData.exam_name + " (" + testData.test_name + ")") ?? ""}</h1>
                                        <div className="space-y-2 w-full flex flex-col items-center p-4">
                                            <div className="flex justify-center items-center w-20 h-20 rounded-[50%] overflow-hidden">
                                                <img className="max-w-full max-h-full w-auto h-auto" src={(userData.photo) ? `${filepath}/public/userImages/org_${userData.organization?.id}/${userData.photo}` : `${filepath}/public/userImages/default_user.png`} />
                                            </div>
                                            <h3 className=""><span className="">{userData.name}</span></h3>
                                            <h3 className="">Roll No. : <span className="">{userData.roll_no}</span></h3>
                                        </div>
                                        <div className="space-y-2 w-full max-h-[45vh] min-h-[45vh] overflow-auto p-4 shadow-[0_0_3px_0_rgb(155,155,155,0.5)] ">
                                            {/* Show all questions in serial order */}
                                            {Object.keys(questionsData).map((subject) => (
                                                <>
                                                    {questionsData[subject].map((ques, index) => (
                                                        <button
                                                            key={ques.id}
                                                            onClick={() => {
                                                                setSelectedSubject(subject);
                                                                setCurrentQuestionIndex(index);
                                                            }}
                                                            // ${(subject === selectedSubject) ? '':'hidden'}
                                                            className={` m-px mr-2 rounded min-w-9 p-1 border-[3px]  hover:shadow-[0px_2px_5px_1px_rgba(155,155,155,0.7)]  ${(subject === selectedSubject && index === currentQuestionIndex) ? 'shadow-[0px_2px_5px_1px_rgba(155,155,155,0.7)]' : ''} ${getButtonStyle(ques.qid, subject)}`}
                                                        >
                                                            {ques.id + 1}
                                                        </button>
                                                    ))}
                                                    {/* {(questionsData[subject].length) ? <hr className="border-white"></hr> : ''} */}
                                                </>
                                            ))}
                                        </div>

                                        <div className="mt-auto flex space-x-4 bottom-0">
                                            <button onClick={() => handleSubmit('submitted')} className="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded">Final Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center w-full fixed bottom-0 bg-teal-900 text-white p-1 z-50">@2024. TestView all rights reserved.</div>
        </>
    )
};